import React from 'react';
import './CompressImage.scss';
import CompressImageForm from './CompressImageForm/CompressImageForm';
const CompressImage = () => {
  return (
    <>
      <h1 className="text-center mrg-t30">Compressor</h1>
      <p className="text-center">Only images and PDFs allowed</p>
      <CompressImageForm />
    </>
  );
};

export default CompressImage;
